import React from 'react';
import { images } from '../../data/images';
import { pillars } from '../../data/firm';
import { ButtonLink } from '../ui/ButtonLink';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeIntro() {
  return <section aria-labelledby="intro-heading" data-id="element-245" data-mp="2jvglv37hq0xc">
      <div className="bg-porcelain" data-id="element-246" data-mp="2jwi720i803ss">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-24 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:py-32" data-id="element-247" data-mp="2jtdvgi2fe5s3">
          <Reveal className="lg:col-span-6" data-id="element-248" data-mp="3cjvxrgvbs34g">
            <div id="intro-heading" data-id="element-249" data-mp="3cjm7ds6dbty8">
              <SectionHeading label="Our approach" title="A More Thoughtful Approach to Executive Search" data-id="element-250" data-mp="2ykd41t39gubo" />
            </div>
            <div className="mt-8 max-w-prose space-y-5 text-lg leading-relaxed text-plum/75" data-id="element-251" data-mp="32lf3a9x6h6dn">
              <p data-id="element-252" data-mp="1n4ohh2tx5xbe">
                Effective executive search begins long before the first candidate conversation. It starts with understanding your organization’s strategy, the leadership its next phase requires, the culture a new leader will join, and the long-term objectives they will be accountable for.
              </p>
              <p data-id="element-253" data-mp="3fveligo16u9r">With that foundation in place, every step — from market mapping to the final shortlist — is guided by what genuinely matters to your organization.</p>
            </div>
            <ButtonLink to="/about" variant="ghost" arrow className="mt-8" data-id="element-254" data-mp="3psaxwxh1w0jl">
              More about our philosophy
            </ButtonLink>
          </Reveal>
          <Reveal className="lg:col-span-5 lg:col-start-8" delay={0.05} data-id="element-255" data-mp="7kl8sdn0bgk2">
            <img src={images.introArchitecture} alt="A calm, light-filled interior with limestone walls and an aubergine lounge chair" loading="lazy" className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-256" data-mp="2nbiywvph2vp" />
          </Reveal>
        </div>
      </div>
      <div className="bg-limestone" data-id="element-257" data-mp="qbcl9o2ajn2o">
        <ul className="mx-auto grid max-w-7xl divide-y divide-plum/10 px-6 md:grid-cols-3 md:divide-x md:divide-y-0 lg:px-10" data-id="element-258" data-mp="leukeza308vm">
          {pillars.map((pillar, i) => <li key={pillar.title} className={`py-12 md:py-16 ${i === 0 ? 'md:pr-10' : 'md:px-10'}`} data-id="element-259" data-mp="3f4hmypzdxota" data-mpi={i}>
              <span className="block h-px w-10 bg-copper" aria-hidden="true" data-id="element-260" data-mp="3o70l4ws87d97" />
              <h3 className="mt-6 font-serif text-3xl font-medium text-aubergine" data-id="element-261" data-mp="3o4w73m0m4xv7">{pillar.title}</h3>
              <p className="mt-3 leading-relaxed text-plum/70" data-id="element-262" data-mp="3sztrfp3cetne">{pillar.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}